import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ActivityRowView } from '@app/areas/dashboard/models/activity-report.model';

/**
 * Per-merchant activity grid (raw p-table — EpTable can't do custom cells).
 * Renders all columns and row-click to drill down.
 */
@Component({
  selector: 'app-dashboard-merchant-table',
  templateUrl: './dashboard-merchant-table.component.html',
  styleUrls: ['./dashboard-merchant-table.component.scss'],
  standalone: true,
  imports: [CommonModule, TableModule, InputTextModule, TooltipModule],
})
export class DashboardMerchantTableComponent {
  @Input() rows: ActivityRowView[] | null = [];

  /** Emits the row selected for the income drill-down. */
  @Output() merchantSelect = new EventEmitter<ActivityRowView>();

  onRowSelect(row: ActivityRowView): void {
    this.merchantSelect.emit(row);
  }
}
